import React from 'react';
import InputMask from 'react-input-mask';

const NumeroGuiaInput = props => {
  const { inputRef, onChange, ...other } = props;
  return (
    <InputMask
      mask="aa999999999PY" // Formato para Correos de Paraguay
      alwaysShowMask
      onChange={event => {
        onChange({
          target: {
            name: props.name,
            value: event.target.value?.toUpperCase()
          }
        });
      }}
      {...other}
    />
  );
};

export default NumeroGuiaInput;
